import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { agentProfileRoute } from '@townsquare/routes/agent-profile';
import { embeddableDirectoryRoute } from '@townsquare/routes/embeddable-directory';
import { kudosProfileRoute } from '@townsquare/routes/kudos-profile';
import { profileRoute } from '@townsquare/routes/profile';
import { teamProfileRoute } from '@townsquare/routes/team-profile';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';

const DirectoryViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "DirectoryPage" */ './components/DirectoryView'),
	loading: () => null,
});

const TeamProfileLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "TeamProfilePage" */ './components/TeamProfile'),
	loading: () => null,
});

const UserProfileLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "UserProfilePage" */ './components/UserProfile'),
	loading: () => null,
});

profileRoute.component = UserProfileLoadable;
export const profileRouterRoute: GlobalHomePageRoute = profileRoute;

teamProfileRoute.component = TeamProfileLoadable;
export const teamProfileRouterRoute: GlobalHomePageRoute = teamProfileRoute;

agentProfileRoute.component = DirectoryViewLoadable;
export const agentProfileRouterRoute: GlobalHomePageRoute = agentProfileRoute;

kudosProfileRoute.component = DirectoryViewLoadable;
export const kudosProfileRouterRoute: GlobalHomePageRoute = kudosProfileRoute;

embeddableDirectoryRoute.component = DirectoryViewLoadable;
embeddableDirectoryRoute.resources = [titanEapCrossFlowQueryResource];
export const embeddableDirectoryRouterRoute: GlobalHomePageRoute = embeddableDirectoryRoute;
